import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CSSProperties } from 'styled-components';

import { So5LeaderboardSeasonality } from '@sorare/core/src/__generated__/globalTypes';

import { seasonalityMessages } from 'lib/so5';

type Props = {
  seasonality: Nullable<So5LeaderboardSeasonality>;
  label: Nullable<string>;
  golden?: boolean;
};

export const SeasonalityLabel = ({ seasonality, label, golden }: Props) => {
  if (!seasonality) {
    return null;
  }

  return (
    <span
      color="var(--c-nd-600)"
      className={classNames({
        'text-gradient-color':
          seasonality === So5LeaderboardSeasonality.IN_SEASON || golden,
      })}
      style={
        {
          '--text-gradient-color': golden
            ? 'var(--c-gradient-gold)'
            : 'linear-gradient( 84deg,  #f8d3da 0%, #b3a9f4 28.32%, #fbe9fb 54.01%, #4f94fd 100% )',
        } as CSSProperties
      }
    >
      {label || <FormattedMessage {...seasonalityMessages[seasonality]} />}
    </span>
  );
};
